var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "add-activity-form" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            size: _vm.formSize,
            rules: _vm.formRules,
            model: _vm.activityForm,
            "label-position": "left",
            "label-width": "7.5rem",
            "validate-on-rule-change": false,
          },
        },
        [
          _c("el-form-item", {
            staticStyle: { "padding-left": "0.625rem" },
            attrs: { label: "基本信息" },
          }),
          _c(
            "div",
            { staticClass: "gary-card" },
            [
              _c(
                "el-form-item",
                { staticClass: "fake-ele", attrs: { label: "渠道：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.channelTypeChange },
                      model: {
                        value: _vm.channel,
                        callback: function ($$v) {
                          _vm.channel = $$v
                        },
                        expression: "channel",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("全部渠道"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("渠道白名单"),
                      ]),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("渠道黑名单"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showChannel
                ? _c(
                    "el-form-item",
                    { attrs: { label: "指定渠道：", prop: "appId" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "18.75rem" },
                        attrs: {
                          type: "textarea",
                          placeholder: "请选择渠道数据",
                        },
                        on: { focus: _vm.handleOpenChannel },
                        model: {
                          value: _vm.activityForm.channel,
                          callback: function ($$v) {
                            _vm.$set(_vm.activityForm, "channel", $$v)
                          },
                          expression: "activityForm.channel",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "活动类型：", prop: "promotionType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "18.75rem" },
                      attrs: { placeholder: "请选择活动类型" },
                      on: { change: _vm.onPromotionTypeChange },
                      model: {
                        value: _vm.activityForm.promotionType,
                        callback: function ($$v) {
                          _vm.$set(_vm.activityForm, "promotionType", $$v)
                        },
                        expression: "activityForm.promotionType",
                      },
                    },
                    _vm._l(_vm.promotionTypes, function (item) {
                      return _c("el-option", {
                        key: item.dictKey,
                        attrs: { label: item.dictValue, value: item.dictKey },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动名称：", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "18.75rem" },
                    attrs: { placeholder: "请输入活动名称" },
                    model: {
                      value: _vm.activityForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.activityForm, "name", $$v)
                      },
                      expression: "activityForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.activityForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.activityForm, "status", $$v)
                        },
                        expression: "activityForm.status",
                      },
                    },
                    _vm._l(_vm.activityStatus, function (item) {
                      return _c(
                        "el-radio",
                        { key: item.dictKey, attrs: { label: item.dictKey } },
                        [_vm._v(_vm._s(item.dictValue))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "过期日期：", prop: "startDate" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "请选择开始时间",
                      "end-placeholder": "请选择结束时间",
                    },
                    on: { change: _vm.handleSelectExpireDate },
                    model: {
                      value: _vm.dateSpan,
                      callback: function ($$v) {
                        _vm.dateSpan = $$v
                      },
                      expression: "dateSpan",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "fake-ele", attrs: { label: "备注：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "18.75rem" },
                    attrs: { type: "textarea", placeholder: "请输入备注信息" },
                    model: {
                      value: _vm.activityForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.activityForm, "remark", $$v)
                      },
                      expression: "activityForm.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "fake-ele", attrs: { label: "活动说明：" } },
                [
                  _c(
                    "avue-ueditor",
                    _vm._b(
                      {
                        ref: "editor",
                        staticStyle: { width: "80%" },
                        model: {
                          value: _vm.activityForm.promotionDescription,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.activityForm,
                              "promotionDescription",
                              $$v
                            )
                          },
                          expression: "activityForm.promotionDescription",
                        },
                      },
                      "avue-ueditor",
                      _vm.options,
                      false
                    )
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "flex-start",
                "margin-top": "0.3125rem !important",
              },
            },
            [
              _c("el-form-item", {
                staticStyle: { "padding-left": "0.625rem" },
                attrs: { label: "活动规则" },
              }),
              _vm.activityForm.promotionType != 3 &&
              _vm.activityForm.promotionType != 4
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.addRule },
                    },
                    [_vm._v("新建活动规则")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._l(_vm.activityForm.ruleList, function (item, index) {
            return _c(
              "div",
              { key: item.id, staticClass: "gary-card" },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "fake-ele",
                    attrs: { label: `活动规则${index + 1}` },
                  },
                  [
                    _vm.activityForm.promotionType != 3 &&
                    _vm.activityForm.promotionType != 4
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: {
                              type: "text",
                              icon: "el-icon-delete",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.delRule(item.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm.activityForm.promotionType == 3
                      ? _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            _vm._s(
                              item.ruleType == 0 ? "邀请用户" : "被邀请用户"
                            )
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.activityForm.promotionType === "4"
                  ? _c(
                      "div",
                      { staticStyle: { padding: "1.5625rem" } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "会员商品：",
                              prop: `ruleList[${index}].leboMemberGoodsIds`,
                            },
                          },
                          [
                            _c("el-cascader", {
                              attrs: {
                                placeholder: "会员商品",
                                props: { multiple: true },
                                options: _vm.memberGoods,
                                clearable: "",
                                size: "small",
                                separator: "-",
                              },
                              on: {
                                change: (val) => {
                                  _vm.$set(item, "leboMemberGoodsIds", val)
                                },
                              },
                              model: {
                                value: item.leboMemberGoodsIds,
                                callback: function ($$v) {
                                  _vm.$set(item, "leboMemberGoodsIds", $$v)
                                },
                                expression: "item.leboMemberGoodsIds",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "商品图片：",
                              prop: `ruleList[${index}].goodsPic`,
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  "before-upload": _vm.checkUpload,
                                  "http-request": (params) => {
                                    _vm.uploadImg(params).then((res) => {
                                      item.goodsPic = res
                                    })
                                  },
                                  listType: "picture-img",
                                  "show-file-list": false,
                                },
                              },
                              [
                                item.goodsPic
                                  ? _c("el-image", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: item.goodsPic,
                                        fit: "scale-down",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon",
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "权益图片：",
                              prop: `ruleList[${index}].rightsPic`,
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  "before-upload": _vm.checkUpload,
                                  "http-request": (params) => {
                                    _vm.uploadImg(params).then((res) => {
                                      item.rightsPic = res
                                    })
                                  },
                                  listType: "picture-img",
                                  "show-file-list": false,
                                },
                              },
                              [
                                item.rightsPic
                                  ? _c("el-image", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: item.rightsPic,
                                        fit: "scale-down",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon",
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "乐播图片：",
                              prop: `ruleList[${index}].leboPic`,
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  "before-upload": _vm.checkUpload,
                                  "http-request": (params) => {
                                    _vm.uploadImg(params).then((res) => {
                                      item.leboPic = res
                                    })
                                  },
                                  listType: "picture-img",
                                  "show-file-list": false,
                                },
                              },
                              [
                                item.leboPic
                                  ? _c("el-image", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: item.leboPic,
                                        fit: "scale-down",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon",
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "按钮图片：",
                              prop: `ruleList[${index}].buttonImageUrl`,
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  "before-upload": _vm.checkUpload,
                                  "http-request": (params) => {
                                    _vm.uploadImg(params).then((res) => {
                                      item.buttonImageUrl = res
                                    })
                                  },
                                  listType: "picture-img",
                                  "show-file-list": false,
                                },
                              },
                              [
                                item.buttonImageUrl
                                  ? _c("el-image", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: item.buttonImageUrl,
                                        fit: "scale-down",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon",
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "跳转页按钮图片：",
                              prop: `ruleList[${index}].addressButtonImageUrl`,
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  "before-upload": _vm.checkUpload,
                                  "http-request": (params) => {
                                    _vm.uploadImg(params).then((res) => {
                                      item.addressButtonImageUrl = res
                                    })
                                  },
                                  listType: "picture-img",
                                  "show-file-list": false,
                                },
                              },
                              [
                                item.addressButtonImageUrl
                                  ? _c("el-image", {
                                      staticClass: "avatar",
                                      attrs: {
                                        src: item.addressButtonImageUrl,
                                        fit: "scale-down",
                                      },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon",
                                    }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "活动说明：",
                              prop: "promotionDescribe",
                            },
                          },
                          [
                            _c(
                              "avue-ueditor",
                              _vm._b(
                                {
                                  ref: "editor",
                                  refInFor: true,
                                  model: {
                                    value: item.promotionDescribe,
                                    callback: function ($$v) {
                                      _vm.$set(item, "promotionDescribe", $$v)
                                    },
                                    expression: "item.promotionDescribe",
                                  },
                                },
                                "avue-ueditor",
                                _vm.richTextOptions,
                                false
                              )
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm.activityForm.promotionType === "5"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "用户",
                              prop: `ruleList[${index}].userType`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: item.userType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "userType", $$v)
                                  },
                                  expression: "item.userType",
                                },
                              },
                              _vm._l(item.userTypeOptions, function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.label,
                                    attrs: { label: item.value },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        item.userType == 1
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "指定标签：",
                                    prop: `ruleList[${index}].userTags`,
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "18.75rem" },
                                      attrs: {
                                        placeholder: "请选择标签",
                                        multiple: "",
                                        "collapse-tags": "",
                                        filterable: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onUserTagChange(index)
                                        },
                                      },
                                      model: {
                                        value: item.userTags,
                                        callback: function ($$v) {
                                          _vm.$set(item, "userTags", $$v)
                                        },
                                        expression: "item.userTags",
                                      },
                                    },
                                    _vm._l(_vm.userTagOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: `(${item.id})${item.tag}`,
                                          value: item.tag,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "fake-ele",
                                  attrs: { label: "用户数量：" },
                                },
                                [_c("span", [_vm._v(_vm._s(item.tagQuantity))])]
                              ),
                            ]
                          : _vm._e(),
                        item.userType == 2
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "指定账号：",
                                    prop: `ruleList[${index}].userMobileImportKey`,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "small",
                                          },
                                          on: { click: _vm.downTemplate },
                                        },
                                        [_vm._v("下载模板")]
                                      ),
                                      _c(
                                        "el-upload",
                                        {
                                          attrs: {
                                            "show-file-list": false,
                                            "before-upload": _vm.beforeUpload,
                                            "http-request": (v) =>
                                              _vm.importExcel(item.myId, v),
                                            multiple: false,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "0.625rem",
                                              },
                                              attrs: {
                                                type: "primary",
                                                size: "small",
                                              },
                                            },
                                            [_vm._v("导入")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "0.625rem",
                                            cursor: "pointer",
                                            color: "#409eff",
                                            "text-decoration": "underline",
                                            "margin-right": "0.625rem",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downPhoneFile(
                                                item.myId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.userMobileFileName)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.delPhoneFile(item.myId)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "客户端：",
                              prop: `ruleList[${index}].isAllPlatform`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: item.isAllPlatform,
                                  callback: function ($$v) {
                                    _vm.$set(item, "isAllPlatform", $$v)
                                  },
                                  expression: "item.isAllPlatform",
                                },
                              },
                              _vm._l(item.clientTypeOptions, function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.label,
                                    attrs: { label: item.value },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        item.isAllPlatform === 0
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "指定客户端：",
                                  prop: `ruleList[${index}].clientTypeList`,
                                },
                              },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    on: { change: _vm.updateRuleList },
                                    model: {
                                      value: item.clientTypeList,
                                      callback: function ($$v) {
                                        _vm.$set(item, "clientTypeList", $$v)
                                      },
                                      expression: "item.clientTypeList",
                                    },
                                  },
                                  _vm._l(
                                    item.clientTypeListOptions,
                                    function (item) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.label,
                                          attrs: { label: item.value },
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "赠品类型：",
                              prop: `ruleList[${index}].coupon`,
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "18.75rem" },
                                attrs: {
                                  value: _vm.getCouponDisplayValue(index),
                                  placeholder: "请选择赠品类型",
                                  filterable: "",
                                  clearable: "",
                                  multiple: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.handleCouponChange($event, index)
                                  },
                                },
                              },
                              _vm._l(_vm.couponList, function (couponItem) {
                                return _c("el-option", {
                                  key: `${index}-${couponItem.id}`,
                                  attrs: {
                                    label: `${couponItem.giftName}`,
                                    value: couponItem.id,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "触发资源位：",
                              prop: `ruleList[${index}].resourceGroupCode`,
                            },
                          },
                          [
                            _c("el-cascader", {
                              staticStyle: { width: "18.75rem" },
                              attrs: {
                                placeholder: "触发资源位",
                                props: { multiple: true },
                                options: item.appResourceGroupCodeOptions,
                                "collapse-tags": "",
                                clearable: "",
                                size: "small",
                                separator: "-",
                              },
                              model: {
                                value: item.resourceGroupCode,
                                callback: function ($$v) {
                                  _vm.$set(item, "resourceGroupCode", $$v)
                                },
                                expression: "item.resourceGroupCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "触发场景：",
                              prop: `ruleList[${index}].triggerScene`,
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "18.75rem" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择触发场景",
                                },
                                model: {
                                  value: item.triggerScene,
                                  callback: function ($$v) {
                                    _vm.$set(item, "triggerScene", $$v)
                                  },
                                  expression: "item.triggerScene",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "页面加载时", value: 1 },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "在页面停留超过N秒时",
                                    value: 2,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: { label: "主动退出页面时", value: 3 },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "从指定业务进入页面时",
                                    value: 4,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "广告库存不足或广告播放失败",
                                    value: 5,
                                  },
                                }),
                                _c("el-option", {
                                  attrs: { label: "无剩余广告机会", value: 6 },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        item.triggerScene === 2
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "停留时间：",
                                  prop: `ruleList[${index}].triggerWaitSeconds`,
                                },
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "18.75rem" },
                                  attrs: { placeholder: "请输入停留时间" },
                                  model: {
                                    value: item.triggerWaitSeconds,
                                    callback: function ($$v) {
                                      _vm.$set(item, "triggerWaitSeconds", $$v)
                                    },
                                    expression: "item.triggerWaitSeconds",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.triggerScene === 4
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "指定业务：",
                                  prop: `ruleList[${index}].sourceBusiness`,
                                },
                              },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    on: { change: _vm.updateRuleList },
                                    model: {
                                      value: item.sourceBusiness,
                                      callback: function ($$v) {
                                        _vm.$set(item, "sourceBusiness", $$v)
                                      },
                                      expression: "item.sourceBusiness",
                                    },
                                  },
                                  _vm._l(
                                    item.sourceBusinessOptions,
                                    function (item) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: item.value,
                                          attrs: { label: item.value },
                                        },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "发放次数类型：",
                              prop: `ruleList[${index}].provideAmountType`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: item.provideAmountType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "provideAmountType", $$v)
                                  },
                                  expression: "item.provideAmountType",
                                },
                              },
                              _vm._l(
                                item.provideAmountTypeOptions,
                                function (item) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: item.value,
                                      attrs: { label: item.value },
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        item.provideAmountType === 4 ||
                        item.provideAmountType === 5
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "发放数量：",
                                  prop: `ruleList[${index}].provideAmount`,
                                },
                              },
                              [
                                _c("el-input-number", {
                                  staticStyle: { width: "18.75rem" },
                                  attrs: { placeholder: "请输入发放数量" },
                                  model: {
                                    value: item.provideAmount,
                                    callback: function ($$v) {
                                      _vm.$set(item, "provideAmount", $$v)
                                    },
                                    expression: "item.provideAmount",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "过期重复发放：",
                              prop: `ruleList[${index}].duplicateProvide`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: item.duplicateProvide,
                                  callback: function ($$v) {
                                    _vm.$set(item, "duplicateProvide", $$v)
                                  },
                                  expression: "item.duplicateProvide",
                                },
                              },
                              _vm._l(
                                item.duplicateProvideOptions,
                                function (item) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: item.value,
                                      attrs: { label: item.value },
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "短信提醒：",
                              prop: `ruleList[${index}].isSmsNotice`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                on: {
                                  change: function ($event) {
                                    return _vm.handleSmsChange(index)
                                  },
                                },
                                model: {
                                  value: item.isSmsNotice,
                                  callback: function ($$v) {
                                    _vm.$set(item, "isSmsNotice", $$v)
                                  },
                                  expression: "item.isSmsNotice",
                                },
                              },
                              _vm._l(_vm.SMSStatus, function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.dictKey,
                                    attrs: { label: item.dictKey },
                                  },
                                  [_vm._v(_vm._s(item.dictValue))]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        item.isSmsNotice == 1
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "短信模板ID：",
                                  prop: `ruleList[${index}].smsNoticeTemplate`,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "18.75rem" },
                                    attrs: { placeholder: "请选择短信模板ID" },
                                    model: {
                                      value: item.smsNoticeTemplate,
                                      callback: function ($$v) {
                                        _vm.$set(item, "smsNoticeTemplate", $$v)
                                      },
                                      expression: "item.smsNoticeTemplate",
                                    },
                                  },
                                  _vm._l(_vm.smsTemplateList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: _vm.itemNaNpxark,
                                        value: item.smsCode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "push提醒：",
                              prop: `ruleList[${index}].isPushNotice`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: item.isPushNotice,
                                  callback: function ($$v) {
                                    _vm.$set(item, "isPushNotice", $$v)
                                  },
                                  expression: "item.isPushNotice",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: "0" } }, [
                                  _vm._v("否"),
                                ]),
                                _c("el-radio", { attrs: { label: "1" } }, [
                                  _vm._v("是"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        item.isPushNotice === "1"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "push模板ID：",
                                  prop: `ruleList[${index}].pushNoticeTemplate`,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "18.75rem" },
                                    attrs: { placeholder: "请选择push模板ID" },
                                    model: {
                                      value: item.pushNoticeTemplate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "pushNoticeTemplate",
                                          $$v
                                        )
                                      },
                                      expression: "item.pushNoticeTemplate",
                                    },
                                  },
                                  _vm._l(_vm.pushTemplateList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm.activityForm.promotionType === "6"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "活动商品：",
                              prop: `ruleList[${index}].additionalGoodsId`,
                            },
                          },
                          [
                            _c("el-cascader", {
                              staticStyle: { width: "18.75rem" },
                              attrs: {
                                props: {
                                  emitPath: false,
                                  disabled: "disabled",
                                },
                                placeholder: "活动商品",
                                options: _vm.memberGoodsOptions,
                                clearable: "",
                                size: "small",
                                separator: "-",
                              },
                              on: {
                                change: (val) => {
                                  _vm.$set(item, "additionalGoodsId", val)
                                  _vm.additionalGoodsChange(index)
                                },
                              },
                              model: {
                                value: item.additionalGoodsId,
                                callback: function ($$v) {
                                  _vm.$set(item, "additionalGoodsId", $$v)
                                },
                                expression: "item.additionalGoodsId",
                              },
                            }),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-left": "20px" },
                                attrs: { type: "success", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.addFreeGoods(index)
                                  },
                                },
                              },
                              [_vm._v("新增加购赠品")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "加购模式：",
                              prop: `ruleList[${index}].additionalMode`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: item.additionalMode,
                                  callback: function ($$v) {
                                    _vm.$set(item, "additionalMode", $$v)
                                  },
                                  expression: "item.additionalMode",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("多选多"),
                                ]),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("多选一"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._l(
                          item.additionalGoodInfos,
                          function (freeGoodsItem, freeIndex) {
                            return _c(
                              "div",
                              {
                                key: freeGoodsItem.myId,
                                staticStyle: {
                                  "background-color": "#efefef",
                                  "margin-top": "20px",
                                },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "fake-ele",
                                    attrs: { label: `赠品${freeIndex + 1}` },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "red" },
                                        attrs: {
                                          type: "text",
                                          icon: "el-icon-delete",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delFreeGoods(
                                              index,
                                              freeIndex
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "赠品选择：",
                                      prop: `ruleList[${index}].additionalGoodInfos[${freeIndex}].giftId`,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "18.75rem" },
                                        attrs: {
                                          placeholder: "请选择赠品类型",
                                          clearable: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.freeGoodsChange(
                                              $event,
                                              index
                                            )
                                          },
                                        },
                                        model: {
                                          value: freeGoodsItem.giftId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              freeGoodsItem,
                                              "giftId",
                                              $$v
                                            )
                                          },
                                          expression: "freeGoodsItem.giftId",
                                        },
                                      },
                                      _vm._l(
                                        item.additionalGoods,
                                        function (additionalGoodItem) {
                                          return _c("el-option", {
                                            key: additionalGoodItem.id,
                                            attrs: {
                                              disabled: _vm.giftDisable(
                                                index,
                                                additionalGoodItem.id
                                              ),
                                              label: `${additionalGoodItem.giftName} ${additionalGoodItem.id}`,
                                              value: additionalGoodItem.id,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "加购金额：",
                                      prop: `ruleList[${index}].additionalGoodInfos[${freeIndex}].additionalAmount`,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "18.75rem" },
                                      attrs: { placeholder: "请输入加购金额" },
                                      model: {
                                        value: freeGoodsItem.additionalAmount,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            freeGoodsItem,
                                            "additionalAmount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "freeGoodsItem.additionalAmount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "触发场景：",
                                      prop: `ruleList[${index}].additionalGoodInfos[${freeIndex}].goodsTriggerScene`,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "18.75rem" },
                                        attrs: {
                                          placeholder: "请选择触发场景",
                                        },
                                        model: {
                                          value:
                                            freeGoodsItem.goodsTriggerScene,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              freeGoodsItem,
                                              "goodsTriggerScene",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "freeGoodsItem.goodsTriggerScene",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "会员购买页",
                                            value: 1,
                                          },
                                        }),
                                        _c("el-option", {
                                          attrs: { label: "活动页", value: 2 },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "是否默认勾选：",
                                      prop: `ruleList[${index}].additionalGoodInfos[${freeIndex}].isDefaultAddGood`,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: freeGoodsItem.isDefaultAddGood,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              freeGoodsItem,
                                              "isDefaultAddGood",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "freeGoodsItem.isDefaultAddGood",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [_vm._v("是")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [_vm._v("否")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        _c("div", [
                          _vm._v(
                            "\n          加购后商品组合 （服务于支付的组合商品ID）\n\n          "
                          ),
                          _c(
                            "div",
                            { staticClass: "add-goods-container" },
                            _vm._l(item.showCombineGoods, function (showItem) {
                              return _c(
                                "div",
                                {
                                  key: showItem.value,
                                  staticClass: "goods-card",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(showItem.label) +
                                      _vm._s("(" + showItem.saleGoodsId + ")") +
                                      "\n              " +
                                      _vm._s(showItem.combineAdditionalAmount) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                      ],
                      2
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "用户",
                              prop: `ruleList[${index}].userType`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: item.userType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "userType", $$v)
                                  },
                                  expression: "item.userType",
                                },
                              },
                              _vm._l(item.userTypeOptions, function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.label,
                                    attrs: { label: item.value },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        item.userType == 1
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "指定标签：",
                                    prop: `ruleList[${index}].userTags`,
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: {
                                        placeholder: "请选择标签",
                                        multiple: "",
                                        "collapse-tags": "",
                                        filterable: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onUserTagChange(index)
                                        },
                                      },
                                      model: {
                                        value: item.userTags,
                                        callback: function ($$v) {
                                          _vm.$set(item, "userTags", $$v)
                                        },
                                        expression: "item.userTags",
                                      },
                                    },
                                    _vm._l(_vm.userTagOptions, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: `(${item.id})${item.tag}`,
                                          value: item.tag,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "fake-ele",
                                  attrs: { label: "用户数量：" },
                                },
                                [_c("span", [_vm._v(_vm._s(item.tagQuantity))])]
                              ),
                            ]
                          : _vm._e(),
                        item.userType == 2
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "指定账号：",
                                    prop: `ruleList[${index}].userMobileImportKey`,
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "small",
                                          },
                                          on: { click: _vm.downTemplate },
                                        },
                                        [_vm._v("下载模板")]
                                      ),
                                      _c(
                                        "el-upload",
                                        {
                                          attrs: {
                                            "show-file-list": false,
                                            "before-upload": _vm.beforeUpload,
                                            "http-request": (v) =>
                                              _vm.importExcel(item.myId, v),
                                            multiple: false,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-left": "10px",
                                              },
                                              attrs: {
                                                type: "primary",
                                                size: "small",
                                              },
                                            },
                                            [_vm._v("导入")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                            cursor: "pointer",
                                            color: "#409eff",
                                            "text-decoration": "underline",
                                            "margin-right": "10px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downPhoneFile(
                                                item.myId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.userMobileFileName)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.delPhoneFile(item.myId)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                        _vm.activityForm.promotionType !== "7"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "触发条件：",
                                  prop: `ruleList[${index}].activeMode`,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "18.75rem" },
                                    attrs: {
                                      placeholder: "请选择赠送条件",
                                      disabled:
                                        _vm.activityForm.promotionType == 3,
                                      filterable: "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onActiveModeChange(index)
                                      },
                                    },
                                    model: {
                                      value: item.activeMode,
                                      callback: function ($$v) {
                                        _vm.$set(item, "activeMode", $$v)
                                      },
                                      expression: "item.activeMode",
                                    },
                                  },
                                  _vm._l(_vm.giveConditions, function (item) {
                                    return _c("el-option", {
                                      key: item.dictKey,
                                      attrs: {
                                        label: item.dictValue,
                                        value: item.dictKey,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        [1].includes(+item.activeMode) &&
                        _vm.activityForm.promotionType !== "7"
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "会员类别：",
                                    prop: `ruleList[${index}].isLeboCloud`,
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      on: {
                                        change: _vm.handleMemberTypeChange,
                                      },
                                      model: {
                                        value: item.isLeboCloud,
                                        callback: function ($$v) {
                                          _vm.$set(item, "isLeboCloud", $$v)
                                        },
                                        expression: "item.isLeboCloud",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "1" } },
                                        [_vm._v("乐播云个人会员")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "会员商品：",
                                    prop: `ruleList[${index}].leboMemberGoodsIds`,
                                  },
                                },
                                [
                                  _c("el-cascader", {
                                    attrs: {
                                      placeholder: "会员商品",
                                      props: { multiple: true },
                                      options: _vm.memberGoods,
                                      clearable: "",
                                      size: "small",
                                      separator: "-",
                                    },
                                    on: {
                                      change: (val) => {
                                        _vm.$set(
                                          item,
                                          "leboMemberGoodsIds",
                                          val
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.leboMemberGoodsIds,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "leboMemberGoodsIds",
                                          $$v
                                        )
                                      },
                                      expression: "item.leboMemberGoodsIds",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        item.activeMode == 14 &&
                        _vm.activityForm.promotionType !== "7"
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "会员商品：",
                                    prop: `ruleList[${index}].leboMemberGoodsIds`,
                                  },
                                },
                                [
                                  _c("el-cascader", {
                                    attrs: {
                                      placeholder: "会员商品",
                                      props: { multiple: true },
                                      options: _vm.autoRenewMemberGoods,
                                      clearable: "",
                                      size: "small",
                                      separator: "-",
                                    },
                                    on: {
                                      change: (val) => {
                                        _vm.$set(
                                          item,
                                          "leboMemberGoodsIds",
                                          val
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.leboMemberGoodsIds,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "leboMemberGoodsIds",
                                          $$v
                                        )
                                      },
                                      expression: "item.leboMemberGoodsIds",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        item.activeMode == 12
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "会员商品：",
                                    prop: `ruleList[${index}].leboMemberGoodsIds`,
                                  },
                                },
                                [
                                  _c("el-cascader", {
                                    attrs: {
                                      placeholder: "会员商品",
                                      props: { multiple: true },
                                      options: _vm.autoRenewMemberGoods,
                                      clearable: "",
                                      size: "small",
                                      separator: "-",
                                    },
                                    on: {
                                      change: (val) => {
                                        _vm.$set(
                                          item,
                                          "leboMemberGoodsIds",
                                          val
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.leboMemberGoodsIds,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          item,
                                          "leboMemberGoodsIds",
                                          $$v
                                        )
                                      },
                                      expression: "item.leboMemberGoodsIds",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          : item.activeMode == 4
                          ? [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "number-limit-item",
                                  attrs: { label: "邀请人数：", required: "" },
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-bottom": "0",
                                      },
                                      attrs: {
                                        label: "",
                                        prop: `ruleList[${index}].provideThreshold`,
                                        "label-width": "0",
                                      },
                                    },
                                    [
                                      _c("span", [_vm._v("邀请")]),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          width: "3.75rem",
                                          margin: "0 0.25rem",
                                        },
                                        attrs: {
                                          min: 1,
                                          step: 1,
                                          precision: 0,
                                          controls: false,
                                        },
                                        model: {
                                          value: item.provideThreshold,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "provideThreshold",
                                              $$v
                                            )
                                          },
                                          expression: "item.provideThreshold",
                                        },
                                      }),
                                      _c("span", [_vm._v(" 人获取奖励，")]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-bottom": "0",
                                      },
                                      attrs: {
                                        label: "",
                                        prop: `ruleList[${index}].maxInvitation`,
                                        "label-width": "0",
                                      },
                                    },
                                    [
                                      _c("span", [_vm._v("最多邀请")]),
                                      _c("el-input-number", {
                                        staticStyle: {
                                          width: "3.75rem",
                                          margin: "0 0.25rem",
                                        },
                                        attrs: {
                                          min: 1,
                                          step: 1,
                                          precision: 0,
                                          controls: false,
                                        },
                                        model: {
                                          value: item.maxInvitation,
                                          callback: function ($$v) {
                                            _vm.$set(item, "maxInvitation", $$v)
                                          },
                                          expression: "item.maxInvitation",
                                        },
                                      }),
                                      _c("span", [_vm._v("人")]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                        _vm.activityForm.promotionType == "7"
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "赠品类型：",
                                  prop: `ruleList[${index}].giftId`,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "18.75rem" },
                                    attrs: {
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择赠品类型",
                                      filterable: "",
                                    },
                                    model: {
                                      value: item.giftId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "giftId", $$v)
                                      },
                                      expression: "item.giftId",
                                    },
                                  },
                                  _vm._l(_vm.couponList, function (couponItem) {
                                    return _c("el-option", {
                                      key: `${index}-${couponItem.id}`,
                                      attrs: {
                                        label: `${couponItem.giftName}`,
                                        value: couponItem.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "赠品类型：",
                                  prop: `ruleList[${index}].giftId`,
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "18.75rem" },
                                    attrs: {
                                      multiple: "",
                                      "collapse-tags": "",
                                      placeholder: "请选择赠品类型",
                                      filterable: "",
                                    },
                                    model: {
                                      value: item.giftId,
                                      callback: function ($$v) {
                                        _vm.$set(item, "giftId", $$v)
                                      },
                                      expression: "item.giftId",
                                    },
                                  },
                                  _vm._l(_vm.giftTypeOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          item.giftName + " (" + item.id + ")",
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                        _vm.activityForm.promotionType !== "7"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "活动说明图片：" } },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          "before-upload": _vm.checkUpload,
                                          "http-request": (params) => {
                                            _vm
                                              .uploadImg(params)
                                              .then((res) => {
                                                item.activityDescriptionImageUrl =
                                                  res
                                                _vm.$forceUpdate()
                                              })
                                          },
                                          "show-file-list": false,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            item.activityDescriptionImageUrl
                                              ? _c("el-image", {
                                                  staticClass: "avatar",
                                                  attrs: {
                                                    src: item.activityDescriptionImageUrl,
                                                    fit: "scale-down",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                },
                                                attrs: {
                                                  type: "primary",
                                                  size: "small",
                                                },
                                              },
                                              [_vm._v("上传图片")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "按钮图片：" } },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          "before-upload": _vm.checkUpload,
                                          "http-request": (params) => {
                                            _vm
                                              .uploadImg(params)
                                              .then((res) => {
                                                item.buttonImageUrl = res
                                                _vm.$forceUpdate()
                                              })
                                          },
                                          "show-file-list": false,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            item.buttonImageUrl
                                              ? _c("el-image", {
                                                  staticClass: "avatar",
                                                  attrs: {
                                                    src: item.buttonImageUrl,
                                                    fit: "scale-down",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                },
                                                attrs: {
                                                  type: "primary",
                                                  size: "small",
                                                },
                                              },
                                              [_vm._v("上传图片")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "跳转页按钮图片：" } },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        attrs: {
                                          "before-upload": _vm.checkUpload,
                                          "http-request": (params) => {
                                            _vm
                                              .uploadImg(params)
                                              .then((res) => {
                                                item.addressButtonImageUrl = res
                                                _vm.$forceUpdate()
                                              })
                                          },
                                          "show-file-list": false,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            item.addressButtonImageUrl
                                              ? _c("el-image", {
                                                  staticClass: "avatar",
                                                  attrs: {
                                                    src: item.addressButtonImageUrl,
                                                    fit: "scale-down",
                                                  },
                                                })
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                },
                                                attrs: {
                                                  type: "primary",
                                                  size: "small",
                                                },
                                              },
                                              [_vm._v("上传图片")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "按钮跳转：",
                                      prop: `ruleList[${index}].purchaseJumpType`,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        on: {
                                          change: () =>
                                            (item.purchaseJumpAddress = null),
                                        },
                                        model: {
                                          value: item.purchaseJumpType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "purchaseJumpType",
                                              $$v
                                            )
                                          },
                                          expression: "item.purchaseJumpType",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [_vm._v("活动会员商品页")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 2 } },
                                          [_vm._v("全部会员商品页")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 3 } },
                                          [_vm._v("指定页面")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                item.purchaseJumpType == 3
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "页面地址：",
                                          prop: `ruleList[${index}].purchaseJumpAddress`,
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "18.75rem" },
                                          attrs: {
                                            placeholder: "请输入页面地址",
                                          },
                                          model: {
                                            value: item.purchaseJumpAddress,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "purchaseJumpAddress",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.purchaseJumpAddress",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "可赠送最大数量：",
                                      prop: `ruleList[${index}].maxAmount`,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "18.75rem" },
                                      attrs: { placeholder: "最大赠送数量" },
                                      model: {
                                        value: item.maxAmount,
                                        callback: function ($$v) {
                                          _vm.$set(item, "maxAmount", $$v)
                                        },
                                        expression: "item.maxAmount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "单账号发放数量：",
                                      prop: `ruleList[${index}].userAmount`,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "18.75rem" },
                                      attrs: { placeholder: "最大赠送数量" },
                                      model: {
                                        value: item.userAmount,
                                        callback: function ($$v) {
                                          _vm.$set(item, "userAmount", $$v)
                                        },
                                        expression: "item.userAmount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "短信提醒：",
                                      prop: `ruleList[${index}].isSmsNotice`,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleSmsChange(index)
                                          },
                                        },
                                        model: {
                                          value: item.isSmsNotice,
                                          callback: function ($$v) {
                                            _vm.$set(item, "isSmsNotice", $$v)
                                          },
                                          expression: "item.isSmsNotice",
                                        },
                                      },
                                      _vm._l(_vm.SMSStatus, function (item) {
                                        return _c(
                                          "el-radio",
                                          {
                                            key: item.dictKey,
                                            attrs: { label: item.dictKey },
                                          },
                                          [_vm._v(_vm._s(item.dictValue))]
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                item.isSmsNotice == 1
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "短信模板ID：",
                                          prop: `ruleList[${index}].smsNoticeTemplate`,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "18.75rem" },
                                            attrs: {
                                              placeholder: "请选择短信模板ID",
                                            },
                                            model: {
                                              value: item.smsNoticeTemplate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "smsNoticeTemplate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.smsNoticeTemplate",
                                            },
                                          },
                                          _vm._l(
                                            _vm.smsTemplateList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: _vm.itemNaNpxark,
                                                  value: item.smsCode,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "push提醒：",
                                      prop: `ruleList[${index}].isPushNotice`,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: item.isPushNotice,
                                          callback: function ($$v) {
                                            _vm.$set(item, "isPushNotice", $$v)
                                          },
                                          expression: "item.isPushNotice",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "0" } },
                                          [_vm._v("否")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "1" } },
                                          [_vm._v("是")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                item.isPushNotice === "1"
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "push模板ID：",
                                          prop: `ruleList[${index}].pushNoticeTemplate`,
                                        },
                                      },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "18.75rem" },
                                            attrs: {
                                              placeholder: "请选择push模板ID",
                                            },
                                            model: {
                                              value: item.pushNoticeTemplate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "pushNoticeTemplate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.pushNoticeTemplate",
                                            },
                                          },
                                          _vm._l(
                                            _vm.pushTemplateList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: item.name,
                                                  value: item.id,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                _vm.activityForm.promotionType === "7"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "发放次数类型：",
                              prop: `ruleList[${index}].provideAmountType`,
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: item.provideAmountType,
                                  callback: function ($$v) {
                                    _vm.$set(item, "provideAmountType", $$v)
                                  },
                                  expression: "item.provideAmountType",
                                },
                              },
                              _vm._l(
                                item.provideAmountTypeOptions,
                                function (item) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: item.value,
                                      attrs: { label: item.value },
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "发放数量：",
                              prop: `ruleList[${index}].provideAmount`,
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "18.75rem" },
                              attrs: { placeholder: "请输入发放数量" },
                              model: {
                                value: item.provideAmount,
                                callback: function ($$v) {
                                  _vm.$set(item, "provideAmount", $$v)
                                },
                                expression: "item.provideAmount",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "级别",
                              prop: `ruleList[${index}].level`,
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "18.75rem" },
                              attrs: { placeholder: "请输入级别" },
                              model: {
                                value: item.level,
                                callback: function ($$v) {
                                  _vm.$set(item, "level", $$v)
                                },
                                expression: "item.level",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "达成奖励任务数",
                      prop: `ruleList[${index}].taskNum`,
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "18.75rem" },
                      attrs: {
                        placeholder: "请输入达成奖励的任务数",
                        type: "number",
                      },
                      model: {
                        value: item.taskNum,
                        callback: function ($$v) {
                          _vm.$set(item, "taskNum", $$v)
                        },
                        expression: "item.taskNum",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c("el-form-item", [
            _c(
              "div",
              { staticStyle: { float: "right" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      loading: _vm.submitLoading,
                      size: _vm.formSize,
                      type: "primary",
                    },
                    on: { click: _vm.handleSubmit },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: _vm.formSize },
                    on: { click: _vm.handleCancel },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("channel-popups", {
        attrs: { "app-id": _vm.activityForm.appId, visible: _vm.showPopups },
        on: {
          "update:visible": function ($event) {
            _vm.showPopups = $event
          },
          comfirm: _vm.handleConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }